export default __webpack_public_path__ + "static/media/prts.6aee854a.png";